module.exports = __webpack_public_path__ + "static/media/icons_Bilan Vestibulaire.03982c80.svg";